import React from 'react'

import LetterLandingCTO from '../LetterLandingCTO';

import logo_target from '../../../images/letterfunnel/cloudplusplus.webp';
import screenshot_target from '../../../images/letterfunnel/joostvunderink.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLandingCTO
      fullname="Joost Vunderink"
      firstname="Joost"
      companyname="CloudPlusPlus"
      competition="Grid Dynamics en Label A"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/joostvunderink.js